import { memo, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import { useTheme } from '../../theme';
import { formatNumber, formatPercent } from '../../utils';
import { ChartTooltip } from '../ui/ChartTooltip';

export const DonutChart = memo(({ data, centerLabel, valueFormatter = formatNumber, height = 200 }) => {
  const { palette } = useTheme();
  const [activeIndex, setActiveIndex] = useState(-1);
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const colorOf = i => palette.chart[i % palette.chart.length];

  return (
    <div>
      <div className='wm-chart wm-donut' style={{ height }}>
        <ResponsiveContainer width='100%' height='100%'>
          <PieChart>
            <Pie
              data={data}
              dataKey='value'
              nameKey='name'
              innerRadius='68%'
              outerRadius='94%'
              paddingAngle={data.length > 1 ? 2 : 0}
              stroke='none'
              animationDuration={700}
              onMouseEnter={(_, i) => setActiveIndex(i)}
              onMouseLeave={() => setActiveIndex(-1)}
            >
              {data.map((entry, i) => (
                <Cell
                  key={entry.name}
                  fill={colorOf(i)}
                  fillOpacity={activeIndex === -1 || activeIndex === i ? 1 : 0.35}
                  style={{ transition: 'fill-opacity 0.15s ease', outline: 'none' }}
                />
              ))}
            </Pie>
            <Tooltip
              content={
                <ChartTooltip
                  valueFormatter={(value, row) =>
                    `${valueFormatter(value)} · ${formatPercent(total ? value / total : 0)}`
                  }
                  items={payload => payload.map(p => ({ ...p, color: p.payload.fill }))}
                />
              }
            />
          </PieChart>
        </ResponsiveContainer>
        <div className='wm-donut__center'>
          <strong>{formatNumber(total)}</strong>
          <span>{centerLabel}</span>
        </div>
      </div>
      <ul className='wm-share-list'>
        {data.map((item, i) => (
          <li
            key={item.name}
            onMouseEnter={() => setActiveIndex(i)}
            onMouseLeave={() => setActiveIndex(-1)}
          >
            <i className='wm-swatch' style={{ background: colorOf(i) }} />
            <span className='wm-share-list__name' title={item.name}>
              {item.name}
            </span>
            <span className='wm-share-list__value'>{valueFormatter(item.value)}</span>
            <span className='wm-share-list__pct'>{formatPercent(total ? item.value / total : 0)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
});
